import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class EdContentSectionLoading extends Vue {

  public columns: number = 0;

  /* Hooks */
  created() {
    this.columns = Math.floor(window.innerWidth / 180);
  }

}